module.exports = __webpack_public_path__ + "static/media/PartyTotalsSocial.c4487c3d.jpg";